<template>
  <div>
    <router-view class="view" keep-alive transition transition-mode="out-in" />
    <page-listar v-if="isIndexOnly()" />
  </div>
</template>

<script>
import Listar from './Listar'

export default {
  name: 'motorista-pendencia-motivo',
  data () {
    return {
      title: 'Motivos Pendência Motorista'
    }
  },
  components: {
    'page-listar': Listar
  },
  methods: {
    isIndexOnly () {
      return this.$router.currentRoute.path === '/motorista-pendencia-motivo' || this.$router.currentRoute.path === '/motorista-pendencia-motivo/'
    }
  },
  mounted () {
    this.$parent.$data.title = this.title
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/motorista-pendencia-motivo/index.vue